import {
  TERMINATE_EMPLOYEE_FETCHING,
  TERMINATE_EMPLOYEE_FAILED,
  TERMINATE_EMPLOYEE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TERMINATE_EMPLOYEE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TERMINATE_EMPLOYEE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TERMINATE_EMPLOYEE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
